import { useEffect, useState } from "react";

// Internal Imports
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import { IQuestionGroup } from "../interfaces/IQuestion";
import { GetQuestionsGroupByUserID } from "../services/questionGroup";


const useListGroupQuestion = () => {

    // States
    const [listGroupQuestion, setListGroupQuestion] = useState<IQuestionGroup[]>([]);
    const [loadingListGroupQ, setLoadingGroupQ] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetGroupsQuestion();
    }, [])

    // Handles
    const handleGetGroupsQuestion = () => {
        setLoadingGroupQ(true);
        tryCatch(() => {
            GetQuestionsGroupByUserID()
                .then((response) => {
                    setListGroupQuestion(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingGroupQ(false));
        })
    }

    return {
        listGroupQuestion,
        setListGroupQuestion,
        loadingListGroupQ,
    }
}


export default useListGroupQuestion;
